import { buildProps } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";

export const tagProps = buildProps({
  type: {
    type: String,
    values: [
      "primary",
      "success",
      "danger",
      "warning",
      "info",
      "deep-info",
      "other",
      "",
    ],
    default: "",
  },
  size: {
    type: String,
    values: ["", "mini"],
    default: "",
  },
  effect: {
    type: String,
    values: ["", "line", "text"],
    default: "",
  },
  closable: {
    type: Boolean,
    default: false,
  },
} as const);

export type TagProps = ExtractPropTypes<typeof tagProps>;
